import { Box, Typography } from "@mui/material";
import { isAccessRoleCode } from "Models/AccessRoleCodes";
import type { AppUser } from "State/Auth/Models/AuthStateModels";
import { Resources, useResource } from "Translations/Resources";
import { MooneIcon } from "Components/Shared/Icons/MooneIcon";
import { Avatar } from "Components/Shared/Avatar/Avatar";
import type { Version } from "Infrastructure/Api/Api";

type Props = {
  user: AppUser;
};

export const UserInfo = ({ user }: Props) => {
  const { t } = useResource();

  const { firstName, lastName, login, accessRoleCode, version } = user;
  const fullName = firstName && lastName ? `${firstName} ${lastName}` : login;
  const role = isAccessRoleCode(accessRoleCode) ? accessRoleCode : null;
  const userType = role
    ? t(Resources.Common.UserType[role])
    : t(Resources.Common.UnknownUserType);

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Avatar user={user} size="medium" />
      <Box>
        <Typography variant="h6" fontWeight={600} fontSize={16}>
          {`${fullName} (${userType})`}
        </Typography>
        <MooneVersion version={version} />
        <Typography color="text.secondary" fontSize={12} lineHeight={1.2}>
          {login}
        </Typography>
      </Box>
    </Box>
  );
};

type MooneVersionProps = {
  version?: Version | null;
};

const MooneVersion = ({ version }: MooneVersionProps) => {
  const { t } = useResource();

  if (!version) {
    return null;
  }

  return (
    <Typography
      color="text.secondary"
      fontSize={14}
      display="flex"
      alignItems="center"
      gap={1}
    >
      {t(Resources.Form.Version[version])}
      <MooneIcon sx={{ height: 16, width: 16 }} />
    </Typography>
  );
};
